import VerificationCode from './VerificationCode'

export default VerificationCode
